import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 17331 16967"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1970275954816">
        <path
          d="M9111 15449 3499 5711l3400 1320c264 99 561-99 561-396V2080h3301v4555c0 297 297 495 561 396l3401-1320-5612 9738zm6866-10828c-99-132-297-165-462-132l-3928 1519V1683c0-230-199-429-429-429H7031c-231 0-429 199-429 429v4358L2674 4522c-165-66-363-33-462 132-99 132-132 331-33 463l6569 11355c165 264 561 264 726 0l6569-11355c66-166 33-363-66-496zM15482 14888c-561 0-1023-462-1023-1024 0-561 462-1023 1023-1023s1023 462 1023 1023c33 562-462 1024-1023 1024zm0-2905c-1023 0-1849 825-1849 1848 0 1024 826 1849 1849 1849s1848-825 1848-1849c34-1023-825-1848-1848-1848zM2080 12808c-462 0-826-363-826-825s363-825 826-825c462 0 825 363 825 825s-363 825-825 825zm0-2476c-924 0-1651 726-1651 1651 0 924 726 1650 1651 1650 924 0 1650-726 1650-1650 0-925-726-1651-1650-1651zM3730 858c231 0 429 198 429 430 0 231-198 429-429 429s-429-198-429-429c33-265 198-430 429-430zm0 1651c694 0 1255-561 1255-1255C4985 561 4423 0 3730 0S2476 561 2476 1254c0 694 561 1255 1254 1255zM1915 15383c237 0 429 192 429 429s-192 429-429 429-430-192-430-429 193-429 430-429zM12379 16109c237 0 429 192 429 429s-192 429-429 429-429-192-429-429 192-429 429-429zM16109 8682c237 0 429 192 429 429s-192 429-429 429-429-192-429-429 192-429 429-429zM14855 825c237 0 429 192 429 429s-192 429-429 429-429-191-429-429c0-237 192-429 429-429zM429 2476c237 0 429 192 429 429s-192 429-429 429S0 3142 0 2905s192-429 429-429z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
